import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/data/lakaData";

const laserPacks = [
  { name: "Zona mini", price: "10€", note: "15 min" },
  { name: "Zona mediana", price: "25€", note: "20 min" },
  { name: "Zona grande", price: "40€", note: "30 min" },
  { name: "Piernas completas + ingles + axilas", price: "60€", note: "45 min" },
  { name: "Cuerpo completo", price: "99€", note: "1 hora" },
];

const LaserBlock = () => {
  const wa = buildWhatsAppLink(
    "Hola LAKA, quiero consultar disponibilidad para depilación láser.",
  );

  return (
    <section
      data-testid="laser-section"
      className="py-24 md:py-32"
      style={{ background: "#FBF6F2" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="laka-eyebrow">Depilación láser</span>
          <h2 className="mt-5 font-serif-laka text-4xl md:text-5xl lg:text-[3.4rem] font-light leading-[1.05] text-[#1A1A1A]">
            Rápida, cómoda y <span className="italic text-[#D6B36A]">adaptada a cada zona</span>
          </h2>
          <p className="mt-6 text-[#1A1A1A]/70 max-w-md leading-relaxed font-light">
            Sesiones diseñadas para conseguir una piel suave y cuidada de forma
            progresiva, con tecnología cómoda y protocolos personalizados.
          </p>
          <a
            data-testid="laser-whatsapp-btn"
            href={wa}
            target="_blank"
            rel="noreferrer"
            className="mt-8 laka-btn-primary inline-flex"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
            Consultar disponibilidad
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="border border-[#D6B36A]/30 bg-[#FBF6F2]">
            {laserPacks.map((p, i) => (
              <div
                key={p.name}
                data-testid={`laser-pack-${i}`}
                className={`flex items-center justify-between gap-4 px-6 md:px-8 py-6 ${
                  i !== laserPacks.length - 1
                    ? "border-b border-[#D6B36A]/20"
                    : ""
                } hover:bg-[#E8DFD1]/40 transition-colors`}
              >
                <div className="flex items-baseline gap-4 min-w-0">
                  <span className="text-[0.6rem] tracking-[0.3em] uppercase text-[#D6B36A] font-medium hidden sm:inline">
                    0{i + 1}
                  </span>
                  <div className="min-w-0">
                    <div className="font-serif-laka text-lg md:text-xl text-[#1A1A1A] truncate">
                      {p.name}
                    </div>
                    <div className="text-[0.72rem] tracking-[0.18em] uppercase text-[#1A1A1A]/50 mt-1">
                      {p.note}
                    </div>
                  </div>
                </div>
                <div className="font-serif-laka text-2xl md:text-3xl text-[#1A1A1A] shrink-0">
                  {p.price}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LaserBlock;
